import React, { useRef } from 'react'
import { useSmoothScroll } from "../hooks/useSmoothScroll";
import { useCustomCursor } from "../hooks/useCustomCursor";
import Navbar from "./Navbar"
import Hero from "./Hero"
import Projects from "./Projects";
import { Toaster } from 'react-hot-toast';
import CustomCursor from "./CustomCursor"
import Skills from "./Skills";
import AboutMe from "./AboutMe";
import Faq from "./Faq";
import ContactMe from "./ContactMe";
import Footer from "./Footer";

export default function Home() {
    let innerCursor = useRef(null);
    let outerCursor = useRef(null);

    // smooth scrolling
    useSmoothScroll();
    // custom cursor
    useCustomCursor(innerCursor, outerCursor);

    return (
        <>
            <CustomCursor innerCursor={innerCursor} outerCursor={outerCursor} />
            <div className="noise" />
            <video src={"/assets/videos/background2.mp4"} autoPlay loop muted className="fixed -z-20 saturate-50 bg-black/90 w-screen h-screen object-cover" />
            <Toaster position="top-left" containerStyle={{ top: 50, left: 0 }} />
            <div id="home" className="h-full max-w-screen overflow-x-hidden">
                <Navbar />
                <Hero />
            </div>
            <Projects />
            <Skills />
            <AboutMe />
            <Faq />
            <ContactMe />
            <Footer />
        </>
    )
}
